import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  Paper,
  useTheme
} from '@mui/material';
import {
  Home as HomeIcon,
  ArrowBack as ArrowBackIcon,
  SentimentDissatisfied as SadIcon
} from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 5,
          borderRadius: 2,
          textAlign: 'center',
          background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
          boxShadow: '0 8px 40px rgba(0, 0, 0, 0.12)'
        }}
      >
        <Box sx={{ mb: 4 }}>
          <SadIcon
            sx={{
              fontSize: 100,
              color: theme.palette.primary.main,
              mb: 2,
              animation: 'float 3s ease-in-out infinite'
            }}
          />
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.main
            }}
          >
            404
          </Typography>
          <Typography
            variant="h4"
            component="h2"
            gutterBottom
            sx={{ fontWeight: 'medium' }}
          >
            الصفحة غير موجودة
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ mb: 4, maxWidth: '600px', mx: 'auto' }}
          >
            عذراً، الصفحة التي تبحث عنها غير موجودة أو تم نقلها أو حذفها.
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            color="primary"
            size="large"
            startIcon={<HomeIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              fontWeight: 'bold',
              boxShadow: theme.shadows[4]
            }}
          >
            العودة للصفحة الرئيسية
          </Button>
          <Button
            onClick={() => window.history.back()}
            variant="outlined"
            color="primary"
            size="large"
            startIcon={<ArrowBackIcon />}
            sx={{
              px: 3,
              py: 1,
              borderRadius: 2,
              fontWeight: 'bold'
            }}
          >
            الرجوع للصفحة السابقة
          </Button>
        </Box>
      </Paper>

      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }
        `}
      </style>
    </Container>
  );
};

export default NotFoundPage;
